import type { ReactNode } from 'react';
import { Link } from '@tanstack/react-router';
import { logoutToLogin } from '@/auth/logout';

export type AdminNavId = 'assessments';

interface NavItem {
  id: AdminNavId;
  label: string;
  to: string;
}

/** Navegação de plataforma. Reusável — novas configs entram como itens aqui. */
const NAV_ITEMS: NavItem[] = [{ id: 'assessments', label: 'Testes', to: '/testes' }];

/**
 * Shell mínimo do admin-app (fundação reusável, spec 005 US3): header com marca +
 * navegação de plataforma + sair. Sem contexto de empresa (config é global).
 */
export function AdminLayout({
  children,
  activeNavId,
}: {
  children: ReactNode;
  activeNavId?: AdminNavId;
}) {
  return (
    <div className="flex min-h-dvh flex-col bg-background text-foreground">
      <header className="flex items-center justify-between border-b border-border px-6 py-3">
        <div className="flex items-center gap-8">
          <span className="font-semibold tracking-tight text-foreground">EURECA Admin</span>
          <nav aria-label="Configurações de plataforma" className="flex items-center gap-5 text-sm">
            {NAV_ITEMS.map((item) => (
              <Link
                key={item.id}
                to={item.to}
                className={
                  activeNavId === item.id
                    ? 'font-medium text-foreground'
                    : 'text-muted-foreground transition-colors hover:text-foreground'
                }
              >
                {item.label}
              </Link>
            ))}
          </nav>
        </div>
        <button
          type="button"
          onClick={logoutToLogin}
          className="rounded-sm text-sm text-muted-foreground transition-colors hover:text-foreground"
        >
          Sair
        </button>
      </header>
      <main className="flex-1 overflow-y-auto px-6 py-8">
        <div className="mx-auto w-full max-w-5xl">{children}</div>
      </main>
    </div>
  );
}
